import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "../lib/api";
import { log } from "../lib/log";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.me()
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (payload) => {
    const u = await api.login(payload);
    setUser(u);
    return u;
  }, []);

  const register = useCallback(async (payload) => {
    const u = await api.register(payload);
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(async () => {
    setUser(null);
    try { await api.logout(); } catch (err) { log.warn("Logout request failed", err?.response?.status); }
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const u = await api.me();
      setUser(u);
      return u;
    } catch (err) {
      log.warn("Could not refresh user", err?.response?.status);
      return null;
    }
  }, []);

  const actions = useMemo(() => ({ login, register, logout, refreshUser }), [login, register, logout, refreshUser]);
  const value = useMemo(() => ({ user, loading, ...actions }), [user, loading, actions]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
